enum ScrollAlign {
  Start = 'start',
  Center = 'center',
  End = 'end',
}
export default ScrollAlign;
